<template>
  <LayoutPage>
    <template #aside>
      <CompositeAsideCard title="Gestion de l'eau" subtitle="Consommation d'eau potable du mois précédent"
        :key-info="store.getWater.month_consuption.toString()" key-info-label="m³ d'eau potable consommés"
        :tips="[{ tipKey: '30 m³ d\'eau de pluie', tipKeyLabel: 'récupérés pour l\'arrosage et les toilettes des bureaux' }, { tipKey: '3 m³/j d\'eau grise', tipKeyLabel: ' traitée grâce à Skywater Clear' }]"
        tip-green-background>
        <template #key-info-icon>
          <IconWaterManagementWhite />
        </template>
      </CompositeAsideCard>
    </template>
    <template #content>
      <CompositeChartSection class="water-management-chart-doughnut" title="Répartition de l'utilisation de l'eau">
        <ChartDoughnut :topLeft="{ label: 'Espaces verts / Circuits techniques', data: 9, unit: '%' }"
          :topRight="{ label: 'Ftiness', data: 6, unit: '%' }"
          :bottomLeft="{ label: 'Restaurant', data: 26, unit: '%' }"
          :bottomRight="{ label: 'Bureaux', data: 57, unit: '%' }"
          :dataset="{ backgroundColor: ['#6489c6', '#92a9d6', '#c4cfe9', '#2271b9'], data: [9, 6, 57, 26] }" isSmall
          :images="{ urls: images, size: 45 }" :cutout="90">

          <p class="dougnhut-center"> 41,5 </p>
          <p> L/j/pers</p>
        </ChartDoughnut>

      </CompositeChartSection>
      <CompositeChartSection class="water-management-chart-lines" title="Consommation d'eau annuelle"
        :chips="[{ title: new Date().getFullYear().toString(), backgroundColor: '#2271b9' }]">
        <ChartBars v-if="isMounted" :datasets="waterDatasets"
          :stepsize="100" yAxisLegend="Consommation d'eau en m³" />
      </CompositeChartSection>
      <CompositeDidYouKnowCard class="water-management-did-you-know" title="Bon à savoir"
        description="Skywater Clear traite les eaux de cuisine des douches et des lavabos du restaurant d’entreprise pour les réintégrer dans les chasses d’eau du restaurant et du R+2"
        vertical :img="LGCWater" />
    </template>
  </LayoutPage>
</template>

<script lang="ts" setup>
import CompositeAsideCard from '@/components/composite/CompositeAside.vue'
import CompositeChartSection from '@/components/composite/CompositeChartSection.vue'
import ChartDoughnut from '@/components/common/charts/ChartDoughnut.vue'
import ChartBars from '@/components/common/charts/ChartBars.vue'
import LayoutPage from '@/components/layout/LayoutPage.vue'
import IconWaterManagementWhite from '@/components/icons/IconWaterManagementWhite.vue'
import IconCloudGreen from '@/components/icons/IconCloudGreen.vue'
import { useDataStore } from '@/stores/store_data'
import { onMounted, ref, computed } from 'vue'
import CompositeDidYouKnowCard from '@/components/composite/CompositeDidYouKnowCard.vue'
import LGCWater from '@/assets/images/toit-soprema.jpg'
import RestaurantSvg from '@/assets/images/icons/restaurant.svg'
import OfficesSvg from '@/assets/images/icons/bureaux.svg'
import DumbellSvg from '@/assets/images/icons/dumbell.svg'
import PlantSvg from '@/assets/images/icons/plant.svg'

const isMounted = ref<boolean>(false)
const store = useDataStore();
const images = [
  PlantSvg,
  DumbellSvg,
  OfficesSvg,
  RestaurantSvg,

]

const waterDatasets = computed(() => {
  const datasets = [
    { backgroundColor: '#0072ce', data: store.getWater.year_consuption_current }
  ]
  
  const hasNonZeroValues = store.getWater.year_consuption_before.some(value => value !== 0)
  if (hasNonZeroValues) {
    datasets.push({ backgroundColor: '#737373', data: store.getWater.year_consuption_before })
  }
  
  return datasets
})

onMounted(() => {
  store.fetchLGCData().then(() => {
    isMounted.value = true
  })
})
</script>

<style scoped lang="scss">
.water-management {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--spacer);
  height: 100%;

  &-did-you-know {
    width: 35%;
    height: 100%;
    z-index: 10;
  }

  &-chart-lines {
    width: 100%;
    height: 100%;
  }

  &-chart-doughnut {
    height: 100%;
    min-width: 20%;
  }
}

.dougnhut-center {
  font-size: 55px;
  font-weight: 700;
  color: var(--vc-primary);

  @media (max-width: 900px) {
    font-size: 40px;
  }

}
</style>
